import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "ACCUEIL",
  "data-model-id": "2:2162"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavSubsection = _resolveComponent("NavSubsection")!
  const _component_ContainerSubsection = _resolveComponent("ContainerSubsection")!
  const _component_FrameWrapperSubsection = _resolveComponent("FrameWrapperSubsection")!
  const _component_ContainerWrapperSubsection = _resolveComponent("ContainerWrapperSubsection")!
  const _component_DivWrapperSubsection = _resolveComponent("DivWrapperSubsection")!
  const _component_DivSubsection = _resolveComponent("DivSubsection")!
  const _component_SectionComponentNodeSubsection = _resolveComponent("SectionComponentNodeSubsection")!
  const _component_Container1Subsection = _resolveComponent("Container1Subsection")!
  const _component_FooterSubsection = _resolveComponent("FooterSubsection")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_NavSubsection),
    _createVNode(_component_ContainerSubsection),
    _createVNode(_component_FrameWrapperSubsection),
    _createVNode(_component_ContainerWrapperSubsection),
    _createVNode(_component_DivWrapperSubsection),
    _createVNode(_component_DivSubsection),
    _createVNode(_component_SectionComponentNodeSubsection),
    _createVNode(_component_Container1Subsection),
    _createVNode(_component_FooterSubsection)
  ]))
}